<template>
  <v-row cols="12" md="12" class="ma-0 pa-0" style="width: -webkit-fill-available">
    <v-col cols="12" md="12">
      <v-row style="height: 100%">
        <v-col cols="12" md="4">
          <v-card class="card pa-4 d-flex flex-column justify-space-between" style="height: 100%; border-radius: 1rem">
            <v-col class="pa-0">
              <div class="d-flex flex-column" style="font-size: 0.9rem; line-height: 1.1; font-weight: 500">
                <span
                  ><v-icon size="16px" color="#28c76f" class="mr-1"> mdi-arrow-up-circle-outline </v-icon
                  >{{ $t('lottery_thai.dashboard_deposit') }}
                </span>
                <span>
                  <span style="font-weight: 500; color: #0d9">{{ QuantityIncome }}</span>
                  {{ $t('lottery_thai.dashboard_lottery_count') }}
                </span>
              </div>
              <div>
                <span style="font-size: 1.25rem !important; font-weight: 700; color: #0d9"
                  >+{{ totalIncome | currency }}
                </span>
              </div>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="card pa-4 d-flex flex-column justify-space-between" style="height: 100%; border-radius: 1rem">
            <v-col class="pa-0">
              <div class="d-flex flex-column" style="font-size: 0.9rem; line-height: 1.1; font-weight: 500">
                <span
                  ><v-icon size="16px" color="#f74b6c" class="mr-1"> mdi-arrow-down-circle-outline </v-icon
                  >{{ $t('lottery_thai.dashboard_win_prize') }}
                </span>
                <span>
                  <span style="font-weight: 500; color: #f74b6c">{{ QuantityExpenses }}</span>
                  {{ $t('lottery_thai.dashboard_lottery_count') }}
                </span>
              </div>
              <div>
                <span style="font-size: 1.25rem !important; font-weight: 700; color: #f74b6c"
                  >-{{ totalExpenses | currency }}
                </span>
              </div>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="card pa-4 d-flex flex-column justify-space-between" style="height: 100%; border-radius: 1rem">
            <v-col class="pa-0">
              <div class="d-flex flex-column" style="font-size: 0.9rem; line-height: 1.1; font-weight: 500">
                <span
                  ><v-icon size="16px" color="#00cfe8" class="mr-1"> mdi-arrow-down-circle-outline </v-icon
                  >{{ $t('lottery_thai.dashboard_profit') }}
                </span>
                <span>
                  {{ $t('lottery_thai.dashboard_lottery_company') }}
                  <span style="font-weight: 500; color: #f74b6c">{{ companyProfit | currency }}</span>
                </span>
              </div>
              <div>
                <span style="font-size: 1.25rem !important; font-weight: 700; color: #00cfe8">{{
                  webProfit | currency
                }}</span>
              </div>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    dashboard: {
      type: Object,
      require: true,
    },
  },
  watch: {},
  computed: {
    QuantityIncome() {
      return this.dashboard.totalQuantity || 0
    },
    totalIncome() {
      return this.dashboard.totalIncome || 0
    },
    QuantityExpenses() {
      return this.dashboard.totalQuantityExpenses || 0
    },
    totalExpenses() {
      return this.dashboard.totalExpenses || 0
    },
    companyProfit() {
      return (
        (this.dashboard.partnerProfit &&
          this.dashboard.partnerProfit.company &&
          this.dashboard.partnerProfit.company.profit) ||
        0
      )
    },
    webProfit() {
      return (
        (this.dashboard.partnerProfit && this.dashboard.partnerProfit.web && this.dashboard.partnerProfit.web.profit) ||
        0
      )
    },
  },
}
</script>
